// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LocationMarkerFilledSubscriptIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="LocationMarkerFilledSubscriptIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M10.064 19.94S16 13.414 16 10.064 13.314 4 10 4s-6 2.715-6 6.065 6.064 9.874 6.064 9.874M10 12.636a2.7 2.7 0 1 1 0-5.399 2.7 2.7 0 0 1 0 5.4" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const LocationMarkerFilledSubscriptIcon = /* @__PURE__ */ Object.assign(
  LocationMarkerFilledSubscriptIconComponent,
  { displayName: 'LocationMarkerFilledSubscriptIcon' },
);
